import { Box } from "@mui/material";
import ContentAdmin from "components/contentAdmin";
import CustomButton from "components/customButton";
import { ReactComponent as SVGIconWhatsApp } from "assets/images/icons/size-40/whats-app.svg";

function SectionFour()
{
	return (
		<Box
			component="section"
			sx={{
				paddingBottom: { lg: "50px", xs: "32px" },
				backgroundColor: "#3C5E94"
			}}
		>
			<h2>
				<ContentAdmin
					keyText="mission-one-firstComplete"
					keyContent="footer-title"
					defaultValue="Still got questions?"
					position="left"
				/>
			</h2>

			<Box
				sx={{
					margin: { xl: "44px auto 0 auto", xs: "32px auto 0 auto" },
					width: "100%",
					maxWidth: { xl: "1140px", lg: "807px", xs: "327px" },
					height: { xl: "641px", lg: "454px", xs: "187px" },
					overflow: "hidden",
					borderRadius: { xl: "24px", xs: "16px" }
				}}
			>
				<iframe
					width="100%"
					height="100%"
					src="https://www.youtube.com/embed/sIrECLoOn7s?si=oXv-siDq_fFExKYG"
					title="YouTube video player"
					allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
					allowFullScreen
					style={{
						border: "unset",
						borderRadius: "inherit"
					}}
				/>
			</Box>

			<Box
				component="footer"
				sx={{
					marginTop: { xl: "60px", xs: "40px" },
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					flexWrap: "wrap",
					gap: "16px 44px",
					"& a:not(.MuiButtonBase-root)": {
						font: { xl: "700 24px 'Open Sans'", xs: "700 18px 'Open Sans'" },
						color: "#FFF",
						textDecoration: "none"
					}
				}}
			>
				<a
					href="https://calendar.app.google/Ar6bsjYF1YRDgeSY7"
					target="_blank"
					rel="noreferrer"
				>
					<ContentAdmin
						keyText="mission-one-firstComplete"
						keyContent="footer-link1"
						defaultValue="Book a call"
						position="left"
					/>
				</a>

				<CustomButton.Base
					component="a"
					href="https://wa.me/+447902635430"
					target="_blank"
					sx={{
						width: { xs: "100%", lg: "auto" },
						order: { xs: "-1", lg: "0" },
						boxShadow: "unset",
						textWrap: "nowrap",
						whiteSpace: "nowrap",
						"& svg": {
							flexShrink: 0
						}
					}}
				>
					<SVGIconWhatsApp />
					Chat on WhatsApp
				</CustomButton.Base>

				<a
					href="https://www.mylifequest.io/faq"
					target="_blank"
					rel="noreferrer"
				>
					<ContentAdmin
						keyText="mission-one-firstComplete"
						keyContent="footer-link2"
						defaultValue="FAQ"
						position="right"
					/>
				</a>
			</Box>
		</Box>
	);
}

export default SectionFour;
